import { render, staticRenderFns } from "./CardMachine.vue?vue&type=template&id=2a9715c6&"
import script from "./CardMachine.vue?vue&type=script&lang=js&"
export * from "./CardMachine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports